import { api } from "./client";

// 运营账号管理(IT-21):内部 operator 表账号。与供应商账号 /suppliers 分离。

export type InternalRole = "sys" | "admin" | "operator" | "finance";

export interface UserAccount {
  id: number;
  username: string;
  role: InternalRole;
  enabled: boolean;
  last_login_at: string | null;
  credential_updated_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface UserPaged {
  items: UserAccount[];
  total: number;
  page: number;
  page_size: number;
}

export interface UserListParams {
  q?: string;
  role?: InternalRole | "";
  enabled?: boolean;
  page?: number;
  page_size?: number;
}

export interface UserCreateBody {
  username: string;
  password: string;
  role: InternalRole;
  enabled?: boolean;
}

export interface UserUpdateBody {
  role?: InternalRole;
  enabled?: boolean;
}

export interface LoginLockout {
  username: string;
  fails: number;
  locked_until: string;
  remaining_seconds: number;
}

function qs(params?: Record<string, string | number | boolean | undefined>): string {
  if (!params) return "";
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "") p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : "";
}

export const usersApi = {
  list: (params?: UserListParams) =>
    api.get<UserPaged>(`/users${qs(params as Record<string, string | number | boolean | undefined>)}`),

  get: (id: number) => api.get<UserAccount>(`/users/${id}`),

  create: (body: UserCreateBody) => api.post<UserAccount>("/users", body),

  update: (id: number, body: UserUpdateBody) => api.put<UserAccount>(`/users/${id}`, body),

  resetPassword: (id: number, password: string) =>
    api.post<{ updated: boolean }>(`/users/${id}/reset-password`, { password }),

  listLockouts: () =>
    api.get<{ items: LoginLockout[]; total: number }>("/user-lockouts"),

  unlock: (username: string) =>
    api.del<{ unlocked: boolean }>(`/user-lockouts/${encodeURIComponent(username)}`),

  changeOwnPassword: (body: { current_password: string; new_password: string }) =>
    api.put<{ updated: boolean }>("/auth/password", body),
};
